module.exports = __webpack_public_path__ + "img/marker-selected.2a398c8c.svg";